export default __webpack_public_path__ + "static/patient-brochure-mobile-83895677b5bc1d3cae1b60b4f4773a0c.png";